import { CollectionModelFieldHeight } from '@ikegps/core-shared';
import { IkeCalcFieldJoin } from './field.join.ikecalc';

const WIRE_ATTACHMENT_HEIGHT = 'wireAttachmentHeight';

export class IkeCalcWireAttachmentHeightFieldJoin extends IkeCalcFieldJoin {
	type = 'IkeCalcWireAttachmentHeightJoin';

	static accepts(field: CollectionModelFieldHeight) {
		return field.schema.id === WIRE_ATTACHMENT_HEIGHT;
	}

	constructor(field: CollectionModelFieldHeight) {
		super(field);
	}

	joins(other: IkeCalcWireAttachmentHeightFieldJoin): boolean {
		const joinableHeight = this.getFieldValue(this.wire, this.field.schema.id);
		if (joinableHeight != null) {
			return false;
		}

		const wireInsulator = this.getFieldValue(this.wire, 'wireInsulator');
		if (this.isDeadEnd(wireInsulator)) {
			return false;
		}

		if (!other.wire.hasField(this.field.schema.id) || this.getFieldValue(other.wire, this.field.schema.id) != null) {
			return false;
		}

		return (
			this.spansOpposing(this.span, other.span) &&
			this.fieldsEqual(this.circuit, other.circuit, 'circuitConstruction') &&
			this.fieldsEqual(this.wire, other.wire, 'wireInsulator') &&
			this.fieldsEqual(this.wire, other.wire, 'wireSize') &&
			this.fieldsEqual(this.wire, other.wire, 'wireQuantity')
		);
	}
}
